import React from 'react';

import {G, SVG} from '../svg';
import {defaultPropTypes} from './default-prop-types';
import {type IconComponent} from './icon-component';

export const BackwardIcon: IconComponent<any> = ({appearance, fill, ...rest}) => (
    <SVG {...rest} viewBox="0 0 24 24">
        <G appearance={appearance} color={fill}>
            <polygon points="10.7 18.7000002 12.1 17.3000002 7.8 13.0000002 20 13.0000002 20 11.0000002 7.8 11.0000002 12.1 6.70000019 10.7 5.30000019 4 12.0000002" />
        </G>
    </SVG>
);
BackwardIcon.propTypes = defaultPropTypes;
BackwardIcon.isPrivate = true;

export default BackwardIcon;
